import { RowDataWebOrder } from "../../components/WebOrderPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the WebOrderTable factory
 */
class WebOrderRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/sales-order/read-range"
        this.accessData = "items"
    }

    create(item: any): RowDataWebOrder {
        const rowDataOrder: RowDataWebOrder = {

            id: item.id,
            uid: item.uid,
            fullname: item.fullname,
            phone_number: item.phone_number,

            salesOrderId: item.salesOrderId,

            price: item.price,

            courierService: item.courierService,
            trackingNumber: item.trackingNumber,

            status: item.status,

            createdAt: item.createdAt,
            updatedAt: item.updatedAt,

            action: "",

            paidAt: item.paidAt,
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        if (extra.startDate && extra.endDate) {
            params["startDate"] = extra.startDate
            params["endDate"] = extra.endDate
        }
        return params
    }
}

let webOrderRow: WebOrderRow | null = null;

export default function getWebOrderRow(): WebOrderRow {
    if (webOrderRow === null)
        webOrderRow = new WebOrderRow()
    return webOrderRow
}